import xhr_headers from './xhr_headers.js'

const uploader = {
  init() {
    // TODO: sortable
    // $('.attached-sortable').sortable({
    //   axis: 'y',
    //   items: '.attached'
    // })

    document.querySelectorAll('.remove-attached').forEach((link) => {
      link.removeAttribute('data-method')
      link.addEventListener('click', event => {
        event.preventDefault();
        if (confirm(link.getAttribute('data-uploader-confirm'))){
          if (link.getAttribute('href')) {
            fetch(link.getAttribute('href'), {
              method: 'delete', 
              headers: xhr_headers
            }).then(response => {
              link.closest('.attached').remove()
            });  
          } else {
            link.closest('.attached').remove()
          }
        }
      })
    })
  }
}

export default uploader
